import { SupplierService } from './organization-profile';

/** DD-3662: a lab asking another lab to become its supplier. */
export enum SupplierRequestStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
}

/** What either lab may see about the other before they are connected. */
export type SupplierRequestLab = {
    _id: string;
    name?: string | null;
    organizationNumber?: string | null;
    city?: string | null;
};

export type SupplierRequest = {
    _id: string;
    requester: SupplierRequestLab;
    supplier: SupplierRequestLab;
    status: SupplierRequestStatus;
    message?: string | null;
    requestedByName?: string | null;
    requestedAt: string;
    decidedAt?: string | null;
    /** DD-3707: why the request was declined, when the decliner gave a reason. */
    declineReason?: string | null;
};

/** DD-3662: where the browsing lab stands with a listed supplier. */
export enum SupplierConnectionState {
    CONNECTED = 'CONNECTED',
    PENDING = 'PENDING',
    NONE = 'NONE',
}

/** A lab in the supplier browser: its public supplier profile only. */
export type SupplierDirectoryLab = {
    _id: string;
    name?: string | null;
    organizationNumber?: string | null;
    street?: string | null;
    zip?: string | null;
    city?: string | null;
    phone?: string | null;
    email?: string | null;
    website?: string | null;
    logoSignedUrl?: string | null;
    /** The profile's second image (staff or premises). */
    staffSignedUrl?: string | null;
    /** The address's map position; null without one. */
    geoLocation?: { latitude: number; longitude: number } | null;
    services: SupplierService[];
    otherService?: string | null;
    description?: string | null;
    /** As the crow flies from the browsing lab; null when either lab has no location. */
    distanceKm?: number | null;
    connection: SupplierConnectionState;
};

export enum SupplierDirectorySort {
    NAME = 'NAME',
    DISTANCE = 'DISTANCE',
}

export type SupplierDirectoryPage = {
    total: number;
    /** Whether the browsing lab has a location, so distance sort and filter apply. */
    ownLocationKnown: boolean;
    labs: SupplierDirectoryLab[];
};
